export const GOODS_DECREASE = 'GOODS_DECREASE'
export const GOODS_INCREASE = 'GOODS_INCREASE'
export const GOODS_SET_COUNT = 'GOODS_SET_COUNT'
export const GOODS_FETCH_COUNT = 'GOODS_FETCH_COUNT'